import { useMemo, useState } from "react"

export interface ReactState<T = any>{
  value: T,
  setValue: (val: T) => void
}

export const useReactState = <T = unknown>(initValue: T) => {
  const [value, setValue] = useState(initValue)

  return useMemo(() => {
    return {
      value,
      setValue
    }
  }, [value, setValue])
}